import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRedo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "m769.515 412.676 159.736 124.462 74.761-188.194z" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "M895.26 412.075c-25.6-94.192-86.94-178.696-178.065-231.308C534.08 75.047 299.584 137.88 193.862 320.993c-105.72 183.114-42.888 417.611 140.226 523.332 91.082 52.586 194.876 63.47 289.212 38.593"
		})
	]
});
export default SvgIconRedo;
